module.exports = __webpack_public_path__ + "static/media/27.a9c07eca.svg";